import './CompletionSummary.css'

export default function CompletionSummary({ title, stats = [], text }) {
  const colorMap = { critical: 'red', warnings: 'amber', compatible: 'green', blocked: 'blue' }

  return (
    <div className="completion-summary">
      <div className="completion-header">
        <div className="completion-icon">✓</div>
        <div className="completion-title">{title}</div>
      </div>
      <div className="completion-stats">
        {stats.map((s, i) => (
          <div key={i} className="completion-stat">
            <div className={`completion-stat-value ${colorMap[s.type] || ''}`}>{s.value}</div>
            <div className="completion-stat-label">{s.label}</div>
          </div>
        ))}
      </div>
      {text && <div className="completion-text">{text}</div>}
    </div>
  )
}
